import NavigationButton from '@/components/navigation/navigation-button';
import { Box, ButtonProps } from '@cmpsr/components';
import { text } from '../../../common/theme';
import { VARS } from '../../../common/constants';
interface StickyButtonProps {
  ctaLink: string;
  ctaButtonStyle?: ButtonProps;
  ctaText?: string;
}

export function StickyButton({ ctaLink, ctaButtonStyle, ctaText = VARS.cta.message }: StickyButtonProps) {
  const defaultButtonStyle: ButtonProps = {
    display: 'flex',
    paddingX: 'spacer-5',
    paddingY: 'spacer-5',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'spacer-2.5',
    flex: '1 0 0',
    borderRadius: '100px',
    background: '#7CF1C7',
    alignSelf: 'stretch',
    width: '100%',
    color: 'darkBlue',
    ...text.body.regular,
  };

  return (
    <Box
      position="fixed"
      bottom="0"
      width={ctaButtonStyle?.width ?? { base: '285px', lg: '600px' }}
      background="gradient.light"
      zIndex="5"
      marginBottom="spacer-4"
      left="50%"
      transform="translateX(-50%)"
    >
      <NavigationButton {...defaultButtonStyle} {...ctaButtonStyle} to={ctaLink}>
        {ctaText}
      </NavigationButton>
    </Box>
  );
}

export default StickyButton;
